import { useSelector } from 'react-redux';

import { useRole } from '../../authentication/hooks/useRole';
import {
  selectIsUserInstituteAllowed,
  selectIsVariantReadOnly,
} from '../redux';

// Editor: Access to modify variants, samples, etc.
export const WORKFLOW_EDIT_ROLES = ['MetaDataEditor', 'Editor'];
// MetaDataEditor: Access to pharma and other advanced metadata
const METADATA_EDIT_ROLES = ['MetaDataEditor'];

export const useVariantAccess = () => {
  const isUserInstituteAllowed = useSelector(selectIsUserInstituteAllowed);
  const isReadOnly = useSelector(selectIsVariantReadOnly);
  const { hasRole, isActive } = useRole();

  const canInteract = isActive && isUserInstituteAllowed && !isReadOnly;

  return {
    isUserInstituteAllowed,
    isReadOnly,
    canEditWorkflow: canInteract && hasRole(WORKFLOW_EDIT_ROLES),
    canEditMetadata: canInteract && hasRole(METADATA_EDIT_ROLES),
    canInteract,
  };
};
